import React,{ useEffect,useState } from 'react';
import CustomerList from './list_non_tax';

export default function Main() {
  return (
       <React.Fragment> 
        <CustomerList data={[]}/> 
    </React.Fragment>
  );
}